<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'app'
    }
</script>

<style lang="less">
    #app {
        font-family: Tahoma, Helvetica, Arial, "\5b8b\4f53", sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }

    .ql-editor{
        overflow-y: auto;
    }

    .ql-container .ql-editor{
        height: auto;
        max-height: 60vh;
    }

    pre {
        white-space: pre-wrap;
        word-wrap: break-word;
        font-size: 16px;
    }

    .taxonomic-key .el-tree-node__content {
        height: 35px !important;
    }

    .genus-species-img {

        & .el-upload-list--picture-card .el-upload-list__item {
            width: 300px;
            height: 200px;
        }

    }

    .table {
        &-content el-table {
            margin-top: 10px;
        }

        &-pagination {
            display: flex;
            justify-content: flex-end;
            margin-top: 20px;
        }

    }

    .ql-size{

    }

    .global-templete-search{
        display:flex;
        flex-direction: row;
        padding:16px;
        box-shadow: 0 0 40px rgba(0,0,0,0.1);
        border-radius: 5px;
        margin: 10px 0 10px 0
    }
    .global-templete-main{
        box-shadow: 0 0 40px rgba(0,0,0,0.1);
        border-radius: 5px;
        margin: 20px 0 20px 0;
        padding: 16px
    }
    .global-templete-main-button{
        display:flex;
        justify-content:space-between;
        align-items: center;
    }
    .global-templete-main-page{
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue